import { useWindowAccess } from '@platformui/core/infrastructure/features/window/window-hook'
import { useEffect, useRef, useState } from 'react'

export enum ActiveToolType {
    Search = 'search',
    None = '',
}
export type ActiveTool = ActiveToolType.Search | ActiveToolType.None

export type ActiveToolInfo = {
    activeTool: ActiveTool
    toggle: (value: ActiveTool) => void
}

export const useActiveTool = (): ActiveToolInfo => {
    const { window } = useWindowAccess()
    const [activeTool, setActiveTool] = useState<ActiveTool>(
        ActiveToolType.None
    )
    const timerRef = useRef<number | null>(null)

    useEffect(() => {
        if (activeTool === ActiveToolType.None) {
            document.body.classList.remove('header-panel-is-open')
        } else {
            document.body.classList.add('header-panel-is-open')
        }

        return () => document.body.classList.remove('header-panel-is-open')
    }, [activeTool])

    const toggle = (id: ActiveTool) => {
        const doToggleOff = id === activeTool

        setActiveTool(doToggleOff ? ActiveToolType.None : id)
    }

    useEffect(() => {
        if (window === null) {
            return
        }

        const setFocus = (id: string) => {
            if (window === null) {
                return
            }

            if (timerRef.current !== null) {
                window.clearTimeout(timerRef.current)
            }

            timerRef.current = window.setTimeout(() => {
                const element = document.getElementById(id)
                if (element !== null) {
                    element.focus()
                }
            }, 420)
        }

        if (activeTool === ActiveToolType.Search) {
            const mq = window.matchMedia('(min-width: 1025px)')
            if (mq.matches) {
                setFocus('global-search')
            }
        }
    }, [activeTool, window])

    return { activeTool, toggle }
}
